module.exports = __webpack_public_path__ + "static/media/w (4).201830e1.jpg";